import React from "react";
import { renderBoldText } from "../utils/helper";
import SourceDialog from "./SourceDialog";
import { useGlobalModalContext } from "../context/GlobalModalContext";
import SentimentFlag from "./SentimentFlag";
import Revenue from '../assets/Revenue.png';
import EBITDA from '../assets/EBITDA.png';
import OM from '../assets/OperatingMargin.png';
import NM from '../assets/NetMargin.png';

function FinancialHealth({ financialHealth }) {
  const { showModal } = useGlobalModalContext();
  const handleSourceClick = () => {
    showModal(<SourceDialog />);
  };
  return (
    <div className="flex flex-col gap-4 ml-8 text-xs">
      Work in progress
      {/* <div className="flex">
        <img src={Revenue} alt='Revenue' style={{ height: '45vh', width: '30vw'}} />
        <img src={EBITDA} alt='Revenue'  style={{ height: '45vh', width: '30vw'}} />
      </div>
      <div className="flex">
      <img src={OM} alt='Revenue'  style={{ height: '45vh', width: '30vw'}} />
      <img src={NM} alt='Revenue'  style={{ height: '45vh', width: '30vw'}} />
      </div> */}
      {/* <h2 className="text-lg font-bold mb-2 text-main">FOCUS AREAS</h2>
      <ul className='max-h-[40vh] overflow-y-scroll pb-4'> */}
      {/* <ul>
        {financialHealth?.metadata?.map((item, index) => (
             <li key={index} className="pb-4">
             <div
               className="text-xs border rounded p-1"
               style={{
                 borderColor: "#A6A6A6",
                 borderLeft: "4px solid #F15A23",
               }}
             >
               <div>
                 <SentimentFlag sentimentFlag={item.sentiment_flag} />
                 <span className="font-bold">{item.title} : </span>
               </div>
               <div className="px-2">{renderBoldText(item.description)}</div>
               <div
                 className="text-right"
                 style={{ cursor: "pointer" }}
                 onClick={handleSourceClick}
               >
                 <u>
                   <i>Source</i>
                 </u>
               </div>
             </div>
           </li>
        ))}
      </ul> */}
    </div>
  );
}

export default FinancialHealth;
